import PropTypes from "prop-types";
import { DataTable } from "components/ui";
import { formatDate } from "utils";

const TherapyDataPreview = ({ data }) => {
  return (
    <div>
      <DataTable
        data={data.result}
        columns={[
          {
            header: "Account Number",
            cell: (row) => row.account_number,
          },
          {
            header: "Data Source",
            cell: (row) => row.data_source,
          },
          {
            header: "Device Serial Number",
            cell: (row) => row.device_serial_number,
          },
          {
            header: "Usage Date",
            cell: (row) => formatDate(row.usage_date),
          },
          {
            header: "Treatment time",
            cell: (row) => row.treatment_minutes,
          },
          {
            header: "Pressure Time",
            cell: (row) => row.pressure_minutes,
          },
          {
            header: "Initial Pressure",
            cell: (row) => row.pressure_init,
          },
          {
            header: "Average Pressure",
            cell: (row) => row.pressure_avg,
          },
          {
            header: "P95 Pressure",
            cell: (row) => row.pressure_p95,
          },
          {
            header: "Max Pressure",
            cell: (row) => row.pressure_max,
          },
          {
            header: "AHI",
            cell: (row) => row.ahi,
          },
          {
            header: "AI",
            cell: (row) => row.ai,
          },
          {
            header: "CAI",
            cell: (row) => row.cai,
          },
          {
            header: "HI",
            cell: (row) => row.hi,
          },
          {
            header: "Leak Time",
            cell: (row) => row.leak_minutes,
          },
          {
            header: "Average Leak",
            cell: (row) => row.leak_avg,
          },
        ]}
      />
    </div>
  );
};

TherapyDataPreview.propTypes = {
  data: PropTypes.shape({
    result: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default TherapyDataPreview;
